// Knob chart
// -----------------------------------

import $ from 'jquery';
import { APP_COLORS } from '../common/constants';
// Knob charts
import 'jquery-knob/js/jquery.knob.js';

function initKnob() {

    if (!$.fn.knob) return;

    var knobLoaderOptions1 = {
        width: '50%', // responsive
        displayInput: true,
        fgColor: APP_COLORS['info']
    };
    $('#knob-chart1').knob(knobLoaderOptions1);

    var knobLoaderOptions2 = {
        width: '50%', // responsive
        displayInput: true,
        fgColor: APP_COLORS['purple'],
        readOnly: true
    };
    $('#knob-chart2').knob(knobLoaderOptions2);

    var knobLoaderOptions3 = {
        width: '50%', // responsive
        displayInput: true,
        fgColor: APP_COLORS['info'],
        bgColor: APP_COLORS['gray'],
        angleOffset: -125,
        angleArc: 250
    };
    $('#knob-chart3').knob(knobLoaderOptions3);

    var knobLoaderOptions4 = {
        width: '50%', // responsive
        displayInput: true,
        fgColor: APP_COLORS['pink'],
        displayPrevious: true,
        thickness: 0.1,
        lineCap: 'round'
    };
    $('#knob-chart4').knob(knobLoaderOptions4);

}

export default initKnob;
